module.exports = __webpack_public_path__ + "img/ic_markets_actived.8f1435ac.svg";